// extracted by mini-css-extract-plugin
export default {"modalTextInputWrapper":"EditStackItemModal_modalTextInputWrapper__DVgmP","modalTextInput":"EditStackItemModal_modalTextInput__azQvd"};